module.exports = __webpack_public_path__ + "img/titlePc21-safeimagekit.bcd120a8.png";